import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.contract.requestPurgeDialog.title',
    defaultMessage: 'Purge request',
    description: 'title of the request purge dialog',
  },
  successTitle: {
    id: 'pages.contract.requestPurgeDialog.successTitle',
    defaultMessage: 'Purge request sent',
    description: 'title of the request purge sent dialog',
  },
  description: {
    id: 'pages.contract.requestPurgeDialog.description',
    defaultMessage:
      'Purging your account will permanently delete all the data records stated below. These can not be recovered. The primary user of the tenant will receive an email with a link that can be used to complete this action.',
    description: 'description of the request purge dialog',
  },
  successDescription: {
    id: 'pages.contract.requestPurgeDialog.successDescription',
    defaultMessage:
      'The link to complete the purge was sent to the owner of this tenant at {signee}. Please contact him/her to proceed with purging the tenant data.',
    description: 'description of the request purge dialog',
  },
  dataToPurge: {
    id: 'pages.contract.requestPurgeDialog.dataToPurge',
    defaultMessage: 'Data to purge',
    description: 'label for the data to purge of the request purge dialog',
  },
  actions: {
    cancel: {
      id: 'actions.cancel',
      defaultMessage: 'Cancel',
      description: 'label of the cancel button',
    },
    requestPurge: {
      id: 'actions.requestPurge',
      defaultMessage: 'Request purge',
      description: 'label of the request purge button',
    },
    close: {
      id: 'actions.close',
      defaultMessage: 'close',
      description: 'label of the close button',
    },
  },
};

export default defineMessages(translations);
